import React, { useState } from 'react'
import "./Join.css"
import { Link } from 'react-router-dom'
let user;
const Join = () => {


  const senduser=()=>{
   user= document.getElementById("joininput").value;
   document.getElementById("joininput").value=""
  }
  const [name,setname] = useState("")

  return (
    <div className='joinPage'>
        <div className='JoinContainer'>
         <img alt="jf" src="https://cdn.dribbble.com/users/427857/screenshots/5027766/media/41b4ad0ed3995a63e6a51b0c7cee43cf.gif"></img>
         <h1>join page</h1>
         <input type="text" placeholder='Enter Your Name'  id="joininput" onChange={(e)=>setname(e.target.value)}></input>
         <Link to="/chat" onClick={(e)=>!name?e.preventDefault():null}><button className='joinbtn' onClick={senduser}>Login</button></Link>
         
        </div>
     
    </div>
  )
}

export default Join
export {user}
